var $ = require('jquery'),
	gc = require('./gc'),
	$w = $(window),
	$b = $('body'),
	Swiper = require('swiper'),
	Mode = require('./mode');
	
require('./track');
	
function getHeaderOffset()
{
	return parseInt($('.toolbar-spacer').height() || 0) + parseInt($('header[role=banner]').height() || 0);
}

var top;

gc.where('.auto-full', function($div){
	$w.on('resize', function(){
		$div.css('height', Math.max(window.innerHeight - getHeaderOffset(), 480)+'px');
		//$div.css('top', getHeaderOffset()+'px');
	}).trigger('resize');
});

function contextWrapper(context){

	var devicePixelRatio = window.devicePixelRatio || 1;

	this.moveTo = function(x, y) {
		context.moveTo(Math.round(x * devicePixelRatio), Math.round(y * devicePixelRatio))
	};
	
	this.lineTo = function(x, y) {
		context.lineTo(Math.round(x * devicePixelRatio), Math.round(y * devicePixelRatio))
	};
	
	this.closePath = function() {
		context.closePath()
	};
};

function bboxToFeature( bbox ){
	return {
		type: 'Feature',
		geometry: {
			type: 'Polygon',
			coordinates: [[
				bbox[0], 
				[bbox[0][0], bbox[1][1]],
				bbox[1],
				[bbox[1][0], bbox[0][1]],
				bbox[0]
			]]
		}
	};
};

gc.where('#world', function( $world ){

	Mode.setDefault('introduction');
	Mode.set('introduction');
	
	gc.where('[data-set-mode]', function($btn){
		$btn.click(function(e){
			e.stopPropagation();
		});
	});
	
	var devicePixelRatio = window.devicePixelRatio || 1,
		canvas = d3.select("#canvas").append("canvas"),
		context = canvas.node().getContext("2d"),
		width, height, dimMin, aspect, wWidth, wHeight,
		projection = d3.geo.orthographic().precision(.5),
		path = d3.geo.path().projection(projection).context(new contextWrapper(context)),
		onResize = function(){},
		initialCoords = [0, -20],
		$investmentsContainer,
		$aspectContainer = $('.aspect-container', $world),
		$canvasContainer = $('.canvas-container', $world),
		investmentsSwiper,
		aspects = {
			landscape: [16/9, 5/4],
			portrait: [9/16, 4/5]
		};
		
	$canvasContainer.append($('[data-views=front-page-news]'));
	
	var InteractionEvent = function( pos ){
	
		this.cancelled = false;
		this.x = pos[0];
		this.y = pos[1];
		this.dx = 0;
		this.dy = 0;
		
		$w.trigger('rise:world:mousedown', [this]);
			
		this.mousemove = function( pos ){
			if(!this.cancelled) {
				this.dx = pos[0]-this.x;
				this.dy = pos[1]-this.y;
				$w.trigger('rise:world:drag', [this]);
			}
		}.bind(this);
		
		this.dragged = function( thresh ){
			return Math.max(Math.abs(this.dx), Math.abs(this.dy)) > (thresh || 0);
		};
	
		this.cancel = function(){
			this.cancelled = true;
		}.bind(this);
		
		this.mouseup = function(){
			this.dragged() && $w.trigger('rise:world:drag:end', [this]);
			!this.dragged(100) && $w.trigger('rise:world:click', [this]);
		}.bind(this);
	};
	
	var CanvasMouseEvent = false;
	
	var eventFuncs = {
		mousedown: function(){
			CanvasMouseEvent = new InteractionEvent(new d3.mouse(this));
	    },
	    mousemove: function(){
			if(CanvasMouseEvent) 
				CanvasMouseEvent.mousemove(new d3.mouse(this));
			else
				$w.trigger('rise:world:hover', [new d3.mouse(this)]);
	    },
	    mouseup: function(){
			CanvasMouseEvent && CanvasMouseEvent.mouseup();
			CanvasMouseEvent = false;	    	
	    }
	};
	
	canvas
		.on('mousedown', eventFuncs.mousedown)
		.on('touchstart', eventFuncs.mousedown)
		.on('mousemove', eventFuncs.mousemove)
		.on('touchmove', eventFuncs.mousemove)
		.on('mouseup', eventFuncs.mouseup)
		.on('touchend', eventFuncs.mouseup);
	    
	$(document).mouseout(function () {
		CanvasMouseEvent && CanvasMouseEvent.mouseup(); // no click when dragged
	    CanvasMouseEvent = false;
	});
	
	$w.on('resize', function(){
		wWidth = $(window).width();
		wHeight = $(window).height() - getHeaderOffset();
		aspect = (wWidth > wHeight) && wWidth > 800 ? 'landscape' : 'portrait';
		
		var oldAspect = $b.attr('data-aspect');
		$b.attr('data-aspect', aspect);
		
		if(oldAspect && (oldAspect != aspect))
			$w.trigger('gc:aspect', [aspect]);
		
		var D = wWidth/wHeight,
			diff = 100,
			f4 = false,
			ratio = 0;
		
		aspects[aspect].forEach(function( d, _f4 ){
			var _d = Math.abs(d-D);
			if( _d < diff ){
				diff = _d;
				f4 = _f4;
				ratio = d;
			}
		});
		
		$aspectContainer[ f4 ? 'addClass' : 'removeClass' ]('five-four');
		
		var removed = canvas.remove();
			
		width = $canvasContainer.width();
		height = $canvasContainer.height();
		dimMin = Math.min(width, height*0.7);
		width = height = dimMin;

		canvas
			.attr("width", width * devicePixelRatio).attr("height", height * devicePixelRatio)
			.style("width", width + "px").style("height", height + "px");
		
		d3.select("#canvas").append(function(){
			return removed.node();
		});

	}).trigger('resize');	
	
	d3.json("/themes/gc/data/world-110m.json", function(error, json) {
		
		var graticule = d3.geo.graticule()(),
			land = topojson.feature(json, json.objects.land),
			mesh = topojson.mesh(json, json.objects.countries),
			features = topojson.feature(json, json.objects.countries).features,
			countries = [],
			investments = [],
			activeInvestment = 0;

		gc.where('[data-views=country-data]', function( $view ){
			$('.views-row', $view).each(function(){
			
				var id = $('.country-110m-id', this).html(),
					country = features.filter(function(d) { return d.id == id; })[0];
			
				country.properties.id = id;
				country.properties.name = $('.country-name', this).html();
				country.properties.alpha2 = $('.country-alpha2', this).html();
				country.properties.bbox = bboxToFeature(d3.geoBounds(country));
				countries.push(country);
			});
		});

		gc.where('[data-views=investments-data]', function( $view ){
		
			var rotationAngle = 0;
		
			$('.views-row', $view).each(function( index ){
			
				var alpha = $('.investment-country', this).html(),
					investment = {
						index: index,
						type: 'Feature',
						properties: {
							name: $('.investment-name a', this).html(),
							alpha2: alpha,
							href: $('.investment-name a', this).attr('href'),
							country: countries.filter(function(c) { return c.properties.alpha2 == alpha; })[0],
							sector: $('.investment-sector', this).html(),
							subtitle: $('.investment-subtitle', this).html(),
							image: $('.investment-image', this).html(),
							goals: []
						},
						geometry: JSON.parse($('.investment-point', this).html())
					}
				;
				
				var R = investment.geometry.coordinates[0]*-1;
				
				if(R < 0)
					R += 360;
				
				if(!rotationAngle) {
				
					rotationAngle = R;
				
				} else {
				
					var diff = R - ((rotationAngle) %360);
					
					if(diff < 120)
						rotationAngle = rotationAngle+360+diff;
					else
						rotationAngle = rotationAngle+diff;			
				}
				
				investment.properties.rotationAngle = rotationAngle;

				investments.push(investment);
			});

			$investmentsContainer = $('<div id="investments"><div class="swiper-container"><div class="swiper-wrapper"></div>    <div class="swiper-button-prev"></div><div class="swiper-button-next"></div></div></div>'),
				$swiperWrapper = $('.swiper-wrapper', $investmentsContainer);
				
			investments.forEach(function(investment, n ){
			
				var $slide = $(
					'<div class="swiper-slide"><div class="investment" data-alpha2="'+ investment.properties.alpha2 +'">'
					+ ( investment.properties.image ? '<div class="thumb-img"><img src="'+ investment.properties.image +'" /></div>' : '')
					+ '<h3><a data-href="'+investment.properties.href+'" data-image="'+ investment.properties.image +'">' + investment.properties.name + '</a></h3>'
					+ '<p>' + investment.properties.subtitle + '</p>'
					+ '</div></div>'
				);
				
				$('a', $slide).click(function(e){
					if(activeInvestment == investment.index)
						location.href = $(this).attr('data-href');
				});
				
				$swiperWrapper.append($slide);
			});
			
			$world.append($investmentsContainer);
			
			$w.on('gc:aspect', function(){
			
				if(investmentsSwiper)
					investmentsSwiper.destroy();

				investmentsSwiper = new Swiper($('.swiper-container', $world)[0], {
					direction: aspect == 'landscape' ? 'vertical' : 'horizontal',
					slidesPerView: 5,
					loop: true,
					mousewheel: true,
					centeredSlides: true,
					slideToClickedSlide: true,
					on: {
						slideChangeTransitionStart: function(){
							$w.trigger('gc:world:goto', [this.realIndex]);
							console.log('slideto', this.realIndex)
						},
						slideChangeTransitionEnd: function(){
							activeInvestment = this.realIndex;
							console.log('slid to', activeInvestment);
						}
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',						
					}
				});
			
			}).trigger('gc:aspect', [aspect]);
			
			var lastRotation = (new Date).getTime();
			
			$w.on('gc:world:rotation', function( e, R, diff, dragState ){
			
				if(!investmentsSwiper || (Mode.get() != 'investments'))
					return;
					
				var time = (new Date).getTime();
				
				if((time - lastRotation) < 1000)
					return;
			
				// ignore backwards drag
				if( dragState.dragging && (diff < 0) )
					return;
			
				var index = activeInvestment,
					investment = investments[ index ],
					rotation = investment.properties.rotationAngle,
					diff = (rotation%360 - R%360);
					
				if(Math.abs(diff) <= 30)
					return;
					
				var nextAngle = R+45,
					nextIndex = index+1 == investments.length ? 0 : index+1;

				if( Math.abs(investments[nextIndex].properties.rotationAngle - nextAngle)%360 > 30 )
					nextIndex = index;
					
				if(index !== nextIndex){
					console.log('rotate to', nextIndex);
					investmentsSwiper.slideNext(300, false);
					activeInvestment = nextIndex;
					
					investments.forEach(function(investment){
						investment.selected = false;
					});
					
					console.log(time - lastRotation)			
					
					investments[activeInvestment].selected = true;
					investments[activeInvestment].timestamp = lastRotation = time;
				}
			});
		});
		
		projection.rotate(initialCoords);
		
		if(aspect == 'landscape'){		
			projection.scale(dimMin / 2 - 100).translate([width / 2, height / 2])
				.clipExtent([
					[0, 0],
					[width, height]
				])
			;
		} else {
		
			projection.scale(Math.max(dimMin / 2, 480)).translate([width / 2, height / 2])
				.clipExtent([
					[0, 0],
					[width, height]
				])
			;			
		
		}
		
		var WorldState = new (function(){
			
			var longitude = initialCoords[0],
				latitude = initialCoords[1],
				progress = 0,
				degPerMsec = .005,
				start,
				animated,
				animationRequest,
				rotationLast = 0,
				rotationTotal = 0,
				country;

			var dragState = {
				dragging: false,
				timestamp: 0
			};
				
			function captureRotation(){
				
				var R = projection.rotate()[0],
					diff = R - rotationLast;
					
				if(diff < -300)
					diff += 360;
				
				rotationLast = R;
				rotationTotal+= diff;
				
				$w.trigger('gc:world:rotation', [R, diff, dragState]);
			};

			function animate(){
				if(!animated){
					animated = true;
					progress = 0;
					start = false;
					initialCoords = [longitude, latitude];
					animationRequest = window.requestAnimationFrame(animateFrame);
				}
			};
			
			function stopAnimation(){
				animated = false;
				animationRequest && cancelAnimationFrame(animationRequest);
				animationRequest = null;
				initialCoords = [longitude, latitude];
			};

			function animateFrame( timestamp ){
				setTimestamp(timestamp);
				draw((new Date).getTime());
				captureRotation();
				if(animated)
					animationRequest = window.requestAnimationFrame(animateFrame);	
			};

			function setTimestamp(timestamp){
				if (!start) start = timestamp;
				progress = timestamp - start;
				longitude = (initialCoords[0] + (progress * degPerMsec)) %360;
			};
			
			$w.on('rise:world:drag', function(e, M){
				
				dragState.timeStamp = (new Date).getTime();
				
				if(!dragState.dragging) {
					stopAnimation();
					dragState.dragging = true;
				} else {
					longitude = (initialCoords[0] + ((M.dx/width)*180)) %360;
					latitude  = Math.min(Math.max(
						(initialCoords[1] + ((M.dy*-1/height/3)*90)) %180,
						-30
					), 20);
					draw(dragState.timeStamp);
					captureRotation();
				}
				
				setTimeout(function(){
					if(dragState.dragging && ((new Date).getTime() - dragState.timeStamp > 500)){
						M.cancel();
						if(!country){
							dragState.dragging = false;							
							animate();
						}
					}
				}, 1000);
			});
			
			$w.on('rise:world:drag:end', function(e, M){
				M.cancel();
				if(!country && dragState.dragging){
					dragState.dragging = false;
					animate();
				}			
			});

			$w.on('gc:world:goto', function(e, index){
			
				stopAnimation();
				dragState.dragging = true;
				
				var ease = d3.ease('quad'),
					duration = 300,
					R = longitude,
					L = latitude,
					diff = (investments[index].properties.rotationAngle - R) %360,
					targetLat = Math.min(Math.max(
						investments[index].geometry.coordinates[1]*-1,
						-30
					), 20),
					diffL = (targetLat-L) %180;
					
				if(diff > 180)
					diff = 0 - (360 -diff);

				if(diff < -180)
					diff = 0 + (360 -diff);
							
					
				investments.forEach(function(investment){
					investment.selected = false;
				});
				
				investments[index].selected = true;
				investments[index].timestamp = (new Date).getTime();

				d3.timer(function(elapsed) {
					if(elapsed > duration){
						dragState.dragging = false;
						longitude = investments[index].properties.rotationAngle %360;
						animate();
						return true;
					}
					var t = (elapsed % duration) / duration;
					longitude = R + (t * diff);
					latitude  = L + (t * diffL);
					draw((new Date).getTime());
					if( country ) // stop
						return true;			
				}, duration);
			});
		
			this.getCoords = function(){
				return [longitude, latitude];
			};
			
			this.animate = function(){
				animate();
			};
			
			this.getSelectedCountry = function(){
				return country;
			};
			
			this.setSelectedCountry = function( c ){
				country = c;
			};

			this.onReady = function( func )
			{
				if( !investments.length )
					var int = setInterval(function(){
						if(!investments.length)
							return;
						clearInterval(int);
						func();
					}, 100);
				else
					func();
			};
			
			$w.on('rise:world:click', function(e, M){
				var point = projection.invert([M.x, M.y]);
				if( point[0] ){
					
					var inv = false;
					
					investments.forEach(function( feature ){
						var c = projection(feature.geometry.coordinates),
							p = [M.x, M.y],
							a = c[0] - p[0],
							b = c[1] - p[1];
							d = Math.sqrt( a*a + b*b );
							
						if(d < 5)
							inv = feature;
					});
					
					if( inv ) {
						
						investmentsSwiper.slideToLoop(inv.index, 0, false);
						$w.trigger('gc:world:goto', [inv.index]);
						activeInvestment = inv.index;
						return;
					}
					
					country = false;
					countries.forEach(function(c){
						c.selected = d3.geoContains(c, point);
						if(c.selected)
							country = c;
					});
					
					if( country ){

						stopAnimation();
						dragState.dragging = true;
						var time = (new Date()).getTime();
						dragState.clickstamp = time;
						
						var ease = d3.ease('quad'),
							duration = 300,
							centroid = d3.geoCentroid(country),
							R = longitude
							L = latitude,
							diff0 = (centroid[0]*-1 - R) %360,
							targetLat = Math.min(Math.max(
								centroid[1]*-1,
								-20
							), 10),
							diff1 = (targetLat - L) %180;						

						d3.timer(function(elapsed) {
							if(elapsed > duration){
								dragState.dragging = false;
								longitude = centroid[0]*-1;
								latitude = targetLat;
								return true;
							}
							var t = (elapsed % duration) / duration;
							longitude = R + (t * diff0);
							latitude = L + (t * diff1);
							draw((new Date).getTime());	
							captureRotation();
							return (dragState.clickstamp > time);				
						}, duration);
						
						
						
						Mode.set('country');
						
						$('h2.name', $countryContainer).html(country.properties.name);
						$('.investments', $countryContainer).html('');
						
						var sorted = investments.concat();
						
						sorted.sort(function(a, b){
							return a.properties.name > b.properties.name ? 1 : -1;
						});
						
						sorted.forEach(function(investment){
							if(investment.properties.alpha2 == country.properties.alpha2){
							
								$('.investments', $countryContainer).append($(
									'<div class="invest-wrapper"><h3><a href="'+investment.properties.href+'" data-image="'+ investment.properties.image +'">' + investment.properties.name + '</a></h3>'
									+ ( investment.properties.image ? '<div class="thumb-img"><img src="'+ investment.properties.image +'" /></div>' : '') + '</div>'
								));
							}
						});
						
					} else {
					
						Mode.set('investments');
					
					}
				}
			});

			$w.on('rise:world:hover', function(e, p){
				var point = projection.invert(p);
				$world.removeClass('hoverstate');
				if( point[0] ){

					countries.forEach(function(country){
						country.hover = d3.geoContains(country, point);
						if(country.hover) $world.addClass('hoverstate');
					});
				}
			});
			
			var $countryContainer = $('.country-container', $world);
			
			$('.close', $countryContainer).click(function(){
				Mode.clear();
			});
			
			$w.on('gc:mode', function(e, mode){
				
				if(mode == 'investments'){
					country = false;
					countries.forEach(function(c){
						c.selected = false;
					});
					animate();
					//$w.trigger('gc:world:goto', [activeInvestment]);
					return;
				}
			});
			
			this.reduceVisiblePoints = function( points ){
			
				var r = projection.rotate()[0]*-1 + 25;
		
				if(r > 180)
					r -=360;
				if(r < -180)
					r += 360;
				
				return points.filter(function(p){					
					return Math.abs(p.geometry.coordinates[0] - r) < 110;
				});
			};

		})();
	  		
	  	function draw( time ){
	  	
	  		projection.rotate(WorldState.getCoords());
	  		
			if(aspect == 'landscape'){
			
				var scale = dimMin / 2 - (dimMin > 500 ? 90 : 30);
			
				projection.scale(scale).translate([width / 2, height / 2 - 20])
					.clipExtent([
						[0, 0],
						[width, height]
					])
				;
			} else {

				var scale = dimMin / 2 - (dimMin > 600 ? 70 : 30);

				scale = Math.min(scale,5500);
					
				if($investmentsContainer)
					scale = Math.min(scale, height - $investmentsContainer.height());
			
				projection.scale(scale).translate([width / 2, height / 2])
					.clipExtent([
						[0, 0],
						[width, height]
					])
				;			
			
			}	  		
	  		
			projection.clipAngle( 
				Math.asin(
					Math.min(1, .5 * Math.sqrt(width * width + height * height) / projection.scale())
				) * (180/Math.PI)
			);
			
			context.clearRect(0, 0, width * devicePixelRatio, height * devicePixelRatio);

			//context.strokeStyle = "#333";
			context.fillStyle = "#336699";
			context.lineWidth = .5 * devicePixelRatio;
			context.beginPath();
			path({type: "Sphere"});
			//context.stroke(); 
			context.fill();
			
			// graticule 
			/*context.strokeStyle = "#999";
			context.lineWidth = .25 * devicePixelRatio;
			context.beginPath();
			_path(graticule);
			context.stroke();*/
			
			// land
			context.fillStyle = "#efefef";
			context.beginPath();
			path(land);
			context.fill();
			
			countries.forEach(function(country){
			
				if(country.selected){
				
					context.fillStyle = "#222222";
					//context.strokeStyle = "#298DC0";
					//context.lineWidth = 1 * devicePixelRatio;
					context.beginPath();
					path( country );
					context.fill();
					//context.stroke();	
								
				
				} else if (country.hover){
				
					context.fillStyle = "#cccccc";
					context.beginPath();
					path( country );
					context.fill();					
				
				} else {
					
					context.fillStyle = "#dddddd";
					context.beginPath();
					path(country);
					context.fill();				
				
				}
			
			});
			
			/*if( WorldState.getCountry() ){
				context.fillStyle = "#7EE5BD";
				//context.strokeStyle = "#298DC0";
				//context.lineWidth = 1 * devicePixelRatio;
				context.beginPath();
				path( WorldState.getCountry() );
				context.fill();
				//context.stroke();				
			}*/
			
			// mesh
		/*	context.strokeStyle = "#fff";
			context.lineWidth = .5 * devicePixelRatio;
			context.beginPath();
			_path(mesh);
			context.stroke();*/
			
			// sphere
			
			if(investments.length) {
			
				var duration = 1500,
					mode = Mode.get(),
					animatedInvestment = false,
					selectedInvestment = false;
			
				investments.forEach(function(investment){
				
					// DEFAULT SMALL DOT but also see last condition which must match this
				
					if(mode != 'investments') {
					
						context.fillStyle = mode == 'country' ? '#FFFFFF' : "#00AC68";	
						//context.filter = "blur(1px)";
						context.beginPath();
					
						var circle = d3.geoCircle()
							.center(investment.geometry.coordinates)
							.radius(1)();					
		
						path( circle );	
						context.fill();	
						//context.filter = 'none';
						
						return;						
					
					}
				
					if(investment.timestamp){
					
						var progress = time - (investment.timestamp);
						
						if(progress < duration) { // animation
						
							animatedInvestment = investment;
							animatedInvestment.progress = progress;
							return;				
							
						}
						
						investment.timestamp = false;
					}
					
					if( investment.selected ){ // big dot
					
						selectedInvestment = investment;
						
						return;	
					
					}
					
					// last condition ===== 
					
					context.fillStyle = "#00AC68";	
					//context.filter = "blur(1px)";			
					context.beginPath();
				
					var circle = d3.geoCircle()
						.center(investment.geometry.coordinates)
						.radius(1)();					
	
					path( circle );	
					context.fill();
					//context.filter = 'none';				
				});
				
				if( animatedInvestment ) {
			
					context.fillStyle = "#000000";				
					context.beginPath();
				
					var circle = d3.geoCircle()
						.center(animatedInvestment.geometry.coordinates)
						.radius(2 * animatedInvestment.progress/duration)();					

					path( circle );	
					context.fill();
					
					context.strokeStyle = "#000000";
					context.globalCompositeOperation = 'multiply';
					context.lineWidth = 1 * devicePixelRatio;
					
					context.globalAlpha = 1/(animatedInvestment.progress/500) - 0.3;
					if(context.globalAlpha > 0.5)
						context.globalAlpha -= 0.5;
					context.beginPath();

					circle = d3.geoCircle()
						.center(animatedInvestment.geometry.coordinates)
						.radius(animatedInvestment.progress/100)();
						
					path( circle );	
					context.stroke();

					context.globalAlpha = 1/(animatedInvestment.progress/400) - 0.5;
					
					if(context.globalAlpha > 0.5)
						context.globalAlpha -= 0.5;
						
					context.beginPath();

					circle = d3.geoCircle()
						.center(animatedInvestment.geometry.coordinates)
						.radius(animatedInvestment.progress/70)();
						
					path( circle );	
					context.stroke();

					context.globalAlpha = 1/(animatedInvestment.progress/400) - 0.2;
					if(context.globalAlpha > 0.5)
						context.globalAlpha -= 0.5;							
					
					context.beginPath();

					circle = d3.geoCircle()
						.center(animatedInvestment.geometry.coordinates)
						.radius((animatedInvestment.progress/30)-20)();
						
					path( circle );	
					context.stroke();
					
					context.globalAlpha = 1;
					context.globalCompositeOperation = 'source-over';				
				
				} else if (selectedInvestment) {

					context.fillStyle = "#000000";				
					context.beginPath();
				
					var circle = d3.geoCircle()
						.center(selectedInvestment.geometry.coordinates)
						.radius(2)();					

					path( circle );	
					context.fill();				
				}		
			}
	  	} // draw
	  	
		$('.screen.sectors-container .sectors', $world).append($('[data-views=sectors]'));
	  	
	  	var $sectorsContainer = $('.screen.sectors-container', $world),
	  		$sectorsDetail = $('.detail', $sectorsContainer);

		$('.sectors article', $sectorsContainer).click(function(e){
			e.preventDefault();
			var sector = $('h2', this).html(),
			invs = investments.filter(function(inv){
				return inv.properties.sector == sector;
			}),
			$inv = $('.investments', $sectorsDetail);
			
			$inv.html('');
			
			invs.forEach(function(inv){
				$inv.append($('<div class="investment"><a href="'+inv.properties.href+'">'+inv.properties.name+'</a></div>'));
			});

			$('.name', $sectorsDetail).html(sector)
			$('.info', $sectorsDetail).html('');
			$('.info', $sectorsDetail).append($('> .content', this).clone());
			
			$sectorsContainer.addClass('detail-mode');
		});
		
		$('.screen.goals-container .goals', $world).append($('[data-views=global-goals]'));
		
		var $goalsContainer = $('.screen.goals-container', $world),
	  		$goalsDetail = $('.detail', $goalsContainer);
		
		gc.where('[data-views=goals-and-investments] .views-row', function($row){
			var href = $('.investment-name a', $row).attr('href'),
				name = $('.goal-name', $row).html(),
				investment = investments.filter(function(investment){
					return investment.properties.href == href;
				})[0];
			
			// may be left out of queue
			if(investment) investment.properties.goals.push(name);
		});
		
		gc.where('.screen.goals-container .goals .views-row', function(){
			var $th = $(this),
				goal = $('h3', this).html(),
				invs = investments.filter(function(inv){
					return inv.properties.goals.indexOf(goal) > -1;
				});
				
			if(!invs.length)
				$th.addClass('no-investments');
			else {
				$th.click(function(){
					var $inv = $('.investments', $goalsDetail);
					$inv.html('');
					invs.forEach(function(inv){
						$inv.append($('<div class="investment"><a href="'+inv.properties.href+'">'+inv.properties.name+'</a></div>'));
					});
					$('.name', $goalsDetail).html(goal);
					$goalsContainer.addClass('detail-mode');
				});
			}		
		});
		
		var $missionContainer = $('.screen.mission-container', $world);
		
		gc.where('.slug-introductory-copy', function($copy, n){
			$('.mission', $missionContainer).append($copy);
			$copy.viewportClass('active', $missionContainer);
		});
		
		$w.on('gc:mode', function(){
			$('.screen', $world).removeClass('detail-mode');
		});

		var $introContainer = $('.screen.intro-container', $world),
	  		$introDetail = $('.intro', $introContainer);
		
		gc.where('.field--name-field-description', function($field){
			$introDetail.prepend($field);
		});
		
		$('.main', $introContainer).click(function(e){
			e.stopPropagation();
			Mode.set('mission');
		});
		
		$introContainer.click(function($e){
			Mode.set('investments');
		});
		
		$('header[role=banner] h1 a').click(function(e){
			e.preventDefault();
			Mode.set('introduction');
		});
		
		$('.close-button button').click(function(e){
		
			switch(Mode.get()){
				case 'global-goals':
					if($goalsContainer.hasClass('detail-mode'))
						return $goalsContainer.removeClass('detail-mode');
					return Mode.set('investments');	
						
				case 'sectors':
					if($sectorsContainer.hasClass('detail-mode'))
						return $sectorsContainer.removeClass('detail-mode');
					return Mode.set('investments');	

				case 'country':
					return Mode.set('investments'); 
						
				default:
					Mode.set('introduction');					
			}
		});
	
		var href = (location.hash || '').split('investment:').pop();
		
		if( href ){
		
			WorldState.onReady(function(){
				
				var investment = investments.filter(function(inv){
					return inv.properties.href == href;
				}).pop();
				
				setTimeout(function(){
					Mode.set('investments');
					investmentsSwiper.slideToLoop(investment.index, 0, false);
					activeInvestment = investment.index;
					$w.trigger('gc:world:goto', [investment.index]);
				}, 1000);
			});
			
		} else
		
			Mode.set('introduction');
			
		var newsInterval,
			newsIndex = 0,
			$news = $('[data-views=front-page-news]'),
			$items = $('.views-row', $news);
			
		$w.on('gc:mode', function(e, mode){
			if(mode == 'investments') {
			
				$items.removeClass('active');
				$items.eq(newsIndex).addClass('active');
			
				newsInterval = setInterval(function(){
					newsIndex = (newsIndex+1 >= $items.length) ? 0 : newsIndex+1;
					$items.removeClass('active');
					$items.eq(newsIndex).addClass('active');
				}, 10000);
			
			} else {
				$items.removeClass('active');
				newsInterval && clearInterval(newsInterval);
			}
		});
		
		$news.append($('<div class="close-button"><button class="close">×</button></div>'));
		
		$('.close', $news).click(function(){
			$news.addClass('dismissed');
		});

		WorldState.animate();

	});	
});

gc.where('.field--name-field-ge-point', function( $field ){

	var $btn = $('<button class="close">&times;</button>');

	$btn.click(function(){
		location.href = '/#investment:' + location.pathname;
	});
	
	$field.append($btn);

	/*var POINT = [$('.latlon-lon', $field).html(), $('.latlon-lat', $field).html()];
	$field.html('');
	
	var devicePixelRatio = window.devicePixelRatio || 1,
		canvas = d3.select($field[0]).append("canvas"),
		context = canvas.node().getContext("2d"),
		width = height = 60,
		projection = d3.geo.orthographic().precision(.5),
		path = d3.geo.path().projection(projection).context(new contextWrapper(context)),
		initialCoords = [POINT[0]*-1, POINT[1]*-1];
	canvas
		.attr("width", width * devicePixelRatio).attr("height", height * devicePixelRatio)
		.style("width", width + "px").style("height", height + "px");
		
	d3.json("/themes/gc/data/world-110m.json", function(error, json) {
		
		var graticule = d3.geo.graticule()(),
			land = topojson.feature(json, json.objects.land),
			mesh = topojson.mesh(json, json.objects.countries),
			features = topojson.feature(json, json.objects.countries).features;

		var longitude = initialCoords[0],
			latitude = initialCoords[1],
			progress = 0,
			degPerMsec = .01,
			start,
			animationRequest;

		function animateFrame( timestamp ){
			setTimestamp(timestamp);
			draw();
			animationRequest = window.requestAnimationFrame(animateFrame);	
		};

		function setTimestamp(timestamp){
			if (!start) start = timestamp;
			progress = timestamp - start;
			longitude = (initialCoords[0] + (progress * degPerMsec)) %360;
		};

	  	function draw(){

	  		projection.rotate([longitude, latitude]);
	  		
	  		var scale = width/2;
	  		
			projection.scale(scale).translate([width / 2, height / 2])
				.clipExtent([
					[0, 0],
					[width, height]
				])
			;	  		
	  		
			projection.clipAngle( 
				Math.asin(
					Math.min(1, .5 * Math.sqrt(width * width + height * height) / projection.scale())
				) * (180/Math.PI)
			);
			
			context.clearRect(0, 0, width * devicePixelRatio, height * devicePixelRatio);

			context.fillStyle = "#336699";
			context.lineWidth = .5 * devicePixelRatio;
			context.beginPath();
			path({type: "Sphere"});
			context.fill();
			
			// land
			context.fillStyle = "#efefef";
			context.beginPath();
			path(land);
			context.fill();

			context.fillStyle = "#000000";				
			context.beginPath();
			
			var circle = d3.geoCircle()
				.center( POINT )
				.radius(3)();
				
			path( circle );	
			context.fill();

	  	} // draw
	  	
	  	animationRequest = window.requestAnimationFrame(animateFrame);
		
	});*/
	
});


//////////////////
// WEBPACK FOOTER
// ./themes/gc/js/world.js
// module id = 12
// module chunks = 0